import { render, staticRenderFns } from "./UOMAndPackageTypes.vue?vue&type=template&id=6baf2aee"
import script from "./UOMAndPackageTypes.vue?vue&type=script&lang=js"
export * from "./UOMAndPackageTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports